var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['draggable', { 'is-empty': _vm.empty }],attrs:{"data-test-class":"l-draggable-icon"}},[(!_vm.empty)?_c('i',{staticClass:"fa fa-arrows color-grey-light l-draggable-icon"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }